/* eslint import/prefer-default-export: 0 */

/**
 * @type {Object}
 */
export const HEADER_CONTROL_WRAPPER_SIZES = {
  DEFAULT: 'default',
  SMALL: 'small',
};
